'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RSSFormat = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../utils');

var _base = require('./base');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @module opensearch/formats/rss
 */

/**
 * Class to parse RSS feeds
 * @constructor RSSFormat
 * @implements {module:opensearch/formats.FormatInterface}
 */
var RSSFormat = exports.RSSFormat = function (_BaseFeedFormat) {
  _inherits(RSSFormat, _BaseFeedFormat);

  function RSSFormat() {
    _classCallCheck(this, RSSFormat);

    return _possibleConstructorReturn(this, (RSSFormat.__proto__ || Object.getPrototypeOf(RSSFormat)).apply(this, arguments));
  }

  _createClass(RSSFormat, [{
    key: 'parse',

    /**
     * Parse the given XML.
     * @param {string} text The XML string to parse.
     * @returns {module:opensearch/formats.SearchResult} The parsed search result
     */
    value: function parse(text) {
      var _this2 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$extraFields = _ref.extraFields,
          extraFields = _ref$extraFields === undefined ? undefined : _ref$extraFields,
          _ref$namespaces = _ref.namespaces,
          namespaces = _ref$namespaces === undefined ? undefined : _ref$namespaces;

      var xmlDoc = (0, _utils.parseXml)(text).documentElement;
      var channel = (0, _utils.getFirstElement)(xmlDoc, null, 'channel');
      var records = (0, _utils.getElements)(channel, null, 'item').map(function (node) {
        var item = {
          id: (0, _utils.getText)(node, 'dc', 'identifier') || (0, _utils.getText)(node, null, 'guid'),
          properties: {
            title: (0, _utils.getText)(node, null, 'title'),
            content: (0, _utils.getText)(node, null, 'description'),
            summary: (0, _utils.getText)(node, null, 'description'),
            links: _this2.parseLinks(node),
            media: _this2.parseMedia(node)
          }
        };

        var box = _this2.parseBox(node);
        if (box) {
          item.bbox = box;
        }

        var geometry = _this2.parseGeometry(node);
        if (geometry) {
          item.geometry = geometry;

          if (!item.bbox) {
            item.bbox = _this2.getBoxFromGeometry(geometry);
          }
        }

        var date = _this2.parseDate(node);
        if (date) {
          item.properties.time = date;
        }

        var eop = _this2.parseEOP(node);
        if (eop) {
          item.properties.eop = eop;
        }

        var s3Path = _this2.parseS3Path(node);
        if (s3Path) {
          item.properties.s3Path = s3Path;
        }

        if (extraFields) {
          _this2.parseExtraFields(node, extraFields, namespaces, item);
        }

        return item;
      });

      return {
        totalResults: parseInt((0, _utils.getText)(channel, 'os', 'totalResults'), 10),
        startIndex: parseInt((0, _utils.getText)(channel, 'os', 'startIndex'), 10),
        itemsPerPage: parseInt((0, _utils.getText)(channel, 'os', 'itemsPerPage'), 10),
        query: {}, // TODO:
        links: this.parseLinks(xmlDoc),
        records: records
      };
    }
  }]);

  return RSSFormat;
}(_base.BaseFeedFormat);


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/formats/rss.js